module.exports = __webpack_public_path__ + "img/tbg.3c703edf.png";